import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import StatusChip from "../components/StatusChip";

export default function Portfolio() {
    const [cases, setCases] = useState([]);

    useEffect(() => {
        api.listReferrals().then(setCases);
    }, []);

    const groups = cases.reduce(
        (acc, c) => {
            const k = c.decision_outcome || c.status || "open";
            acc[k] = acc[k] || [];
            acc[k].push(c);
            return acc;
        },
        {}
    );

    const totalReceipts = cases.reduce((s, c) => s + (c.receipt_count || 0), 0);
    const totalFlags = cases.reduce((s, c) => s + (c.flag_count || 0), 0);

    return (
        <div data-testid="portfolio-page">
            <div className="mb-10">
                <p className="label-eyebrow mb-3">Portfolio view</p>
                <h1 className="font-serif text-5xl sm:text-6xl tracking-tight text-ink">
                    Governed exception portfolio
                </h1>
                <p className="mt-5 text-lg text-ink-secondary max-w-3xl">
                    Outcomes from referrals across the cyber underwriting book. KATLAS receipts are the audit trail.
                </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
                <Stat label="Open referrals" value={cases.length} />
                <Stat label="Flags raised" value={totalFlags} />
                <Stat label="Receipts recorded" value={totalReceipts} />
            </div>

            <div className="space-y-10">
                {Object.entries(groups).map(([k, list]) => (
                    <div key={k}>
                        <div className="flex items-baseline justify-between mb-4">
                            <h2 className="font-serif text-2xl text-ink">
                                {k.replace(/_/g, " ")}
                            </h2>
                            <StatusChip status={k} />
                        </div>
                        <div className="panel divide-y divide-parchment-rule">
                            {list.map((c) => (
                                <Link
                                    key={c.id}
                                    to={`/case/${c.id}`}
                                    className="grid grid-cols-12 gap-3 px-5 md:px-6 py-4 hover:bg-[#F2EFE9] transition-colors"
                                    data-testid={`portfolio-row-${c.id}`}
                                >
                                    <div className="col-span-12 md:col-span-3 data-cell text-xs">{c.submission_ref}</div>
                                    <div className="col-span-12 md:col-span-3 text-sm text-ink">{c.insured_label}</div>
                                    <div className="col-span-6 md:col-span-2 text-sm text-ink-secondary">{c.broker_partner}</div>
                                    <div className="col-span-6 md:col-span-2 text-sm">{c.sector}</div>
                                    <div className="col-span-12 md:col-span-2 text-right data-cell text-xs">
                                        {c.flag_count} flag · {c.receipt_count} receipt
                                    </div>
                                </Link>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

function Stat({ label, value }) {
    return (
        <div className="panel p-6">
            <div className="label-eyebrow mb-2">{label}</div>
            <div className="font-serif text-5xl text-ink">{value}</div>
        </div>
    );
}
